const columns = [
  { id: 'title', label: 'Titulo', minWidth: 170 },
  { id: 'startDate', label: 'Fecha de Inicio del Mensaje', minWidth: 120, type: 'date' },
  { id: 'endDate', label: 'Fecha de Fin del Mensaje', minWidth: 120, type: 'date' },
  { id: 'membershipType', label: 'Enviado a usuarios con membresia:', minWidth: 170 },
  { id: 'views_count', label: 'Leido por:', minWidth: 170 },
];

const config = {
  columns,
};

export default config;
